export enum UserDocType {
    CREATOR = "creator",
    NEW_ENTRY = "new_entry",
    IN_CHARGE = "in_charge"
}